var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content"},[_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":_vm.noContent}}),_c('p',[_vm._v("暂无内容")])])])}
var staticRenderFns = []

export { render, staticRenderFns }